import api from '@/plugins/api'
import { inspection as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'inspection'
import notify from '@ananasbear/notify';
import router from '@/router'
import { list as statusesList } from '@/configs/statuses'

export default {
  state: () => ({
    dependency: {},
    inspection: {},
    decisionIssue: {},
    decisionIssueRejectId: null,
    certificate: {},
    lightTransmissionMeasurement: [],
    lightMeasurement: {},
    brakeMeasurement: {},
    gasMeasurement: [],
    smokeMeasurement: [],
    noiseMeasurement: {},
    questions: [],
    vehicle: [],
    vehicleHeadlight: [],
    carcassTypes: [],
    proofs: [],
    isLoadFindVehicle: false,
    measurementResult: {},
    showPassMeasurementIndex: null,
    errorDownloadCompliance: false,
    listAttachmentPointsSeatBelt: [
      { value: 3, name: '3' },
      { value: 2, name: '2' },
      { value: 4, name: '2*' }
    ],
    seatPositions: [
      { value: 'L', name: 'Зліва (L)' },
      { value: 'R', name: 'Справа (R)' },
      { value: 'C', name: 'По центру (C)' }
    ],
    carcassBooleanAnswerList: [
      { name: 'Є', value: true },
      { name: 'Нема', value: false }
    ],
    inStock: [
      { name: 'Присутнє', value: true },
      { name: 'Відсутнє', value: false }
    ],
    neutralizerList: [
      { id: 1, name: 'Окислювальний нейтралізатор'},
      { id: 2, name: 'Трикомпонентний нейтралізатор'}
    ],
    equipmentList: [],
    equipment: null,
    inspectionMeasurementResult: null
  }),
  actions: {
    async setInspection (context, data) {
      const response = await api.post(endpoint.inspection, { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getStatement', data.id)
      return { isResult, id: response.data.id }
    },
    async getInspection (context, id) {
      const response = await api.get(endpoint.action(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'inspection', data: response.data })
        if (statusesList.inspectionWaitComplianceCompleted === context.state.inspection.status_document &&
          !context.state.questions.length) {
          let timerGetQuestions = 60
          const timer = setInterval(() => {
            timerGetQuestions--
            context.dispatch('getInspectionQuestions', context.state.inspection.id)
            if (context.state.questions.length) {
              clearInterval(timer)
            } else if (!context.state.questions.length && timerGetQuestions === 0) {
              notify.error('errorDownloadCompliance')
              context.commit('SET_DATA', { store, state: 'errorDownloadCompliance', data: true })
              clearInterval(timer)
            }
          }, 800)
        }
      }
      return isResult
    },
    async updateInspection (context, data) {
      const response = await api.patch(endpoint.action(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) context.dispatch('getInspection', data.id)
      return isResult
    },
    async updateInspectionFromFinalization (context, data) {
      const response = await api.put(endpoint.action(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      return { isResult, id: response.data.id }
    },
    async getVehicle (context, params) {
      context.commit('SET_DATA', { store, state: 'isLoadFindVehicle', data: true })
      const response = await api.get(endpoint.findVehicle(params))
      if (await requestValidation(response)) {
        await Promise.all(response.data.results.map(async vehicle => {
          let modelObject = context.getters.directoryById('vehicleModel', vehicle.vehicle_model)
          if (!modelObject) modelObject = await context.dispatch('getDirectoryById', {
            endpoint: 'vehicleModel',
            state: 'vehicleModel',
            id: vehicle.vehicle_model
          })

          vehicle.vehicleMarkAndModel =
            `${ context.getters.directoryById('vehicleMark', modelObject.vehicle_mark)?.name }
            ${ modelObject.name }`
        }))

        context.commit('SET_DATA', { store, state: 'vehicle', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoadFindVehicle', data: false })
    },
    async getVehicleHeadlight (context, id) {
      const response = await api.get(endpoint.getVehicleHeadlight(id))
      const isResult = await requestValidation(response)
      if (isResult) context.commit('SET_DATA', { store, state: 'vehicleHeadlight', data: response.data })
      return isResult
    },
    async setInspectionSign (context, payload) {
      const response = await api.post(endpoint.signCompliance, { body: { document: payload.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getInspection', response.data.document)
        if (payload.isGetDecisionIssue) await context.dispatch('getDecisionIssue', response.data.document)
      }
      return isResult
    },
    async getInspectionProtocolPDF (context, id) {
      const response = await api.get(endpoint.inspectionProtocolPdf(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    // dependency fields for inspection
    async getDependency (context, statementID) {
      const response = await api.get(endpoint.dependency(statementID))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'dependency', data: response.data })
      }
    },
    // inspection compliance for inspection protocol
    async getInspectionQuestions (context, id) {
      const response = await api.get(`${ endpoint.legalActQuestions(id) }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'questions', data: response.data })
      }
      return isResult
    },
    async getInspectionInconsistenciesQuestions (context, id) {
      const response = await api.get(endpoint.inconsistency(id))
      const isResult = await requestValidation(response)
      return isResult ? response.data : []
    },
    async updateInspectionInconsistenciesQuestions (context, payload) {
      const response = await api.patch(endpoint.inconsistencyAction(
        payload.id, payload.discrepancyId),
        { body: payload.body }
      )
      return await requestValidation(response)
    },
    async setInspectionAnswers (context, data) {
      const response = await api.patch(endpoint.questionsActions(data.inspectionID), { body: data.body })
      return await requestValidation(response)
    },
    async getDecisionLegalActs (context, id) {
      const response = await api.get(`${ endpoint.decisionLegalActs(id) }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'questions', data: response.data.results })
      }
      return isResult
    },
    async setDecisionLegalAct (context, data) {
      const response = await api.patch(
        endpoint.setDecisionLegalAct(context.state.decisionIssue.id, data.id),
        { body: data }
      )
      const isResult = await requestValidation(response)
      if (isResult) {
        setTimeout(async () => {
          await context.dispatch('getDecisionIssue', context.state.inspection.id)
          await context.dispatch('getInspection', context.state.inspection.id)
        }, 1000)
      }
      return isResult
    },
    // measurements
    async getLightTransmissionMeasurement (context, id) {
      const response = await api.get(endpoint.getLightTransmission(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightTransmissionMeasurement (context, data) {
      const response = await api.post(endpoint.setLightTransmission(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightTransmissionMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getBrakeMeasurement (context, id) {
      const response = await api.get(endpoint.brake(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
      }
      return isResult
    },
    async setBrakeMeasurement (context, data) {
      const response = await api.post(endpoint.brake(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'brakeMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getLightMeasurement (context, id) {
      const response = await api.get(endpoint.light(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
      }
      return isResult
    },
    async setLightMeasurement (context, data) {
      const response = await api.post(endpoint.light(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'lightMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getGasMeasurement (context, id) {
      const response = await api.get(endpoint.getGas(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setGasMeasurement (context, data) {
      const response = await api.post(endpoint.setGas(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'gasMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getSmokeMeasurement (context, id) {
      const response = await api.get(endpoint.getSmoke(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data.results })
      }
      return isResult
    },
    async setSmokeMeasurement (context, data) {
      const response = await api.post(endpoint.setSmoke(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'smokeMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getNoiseMeasurement (context, id) {
      const response = await api.get(endpoint.noise(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
      }
      return isResult
    },
    async setNoiseMeasurement (context, data) {
      const response = await api.post(endpoint.noise(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'noiseMeasurement', data: response.data })
        await context.dispatch('getInspection', data.id)
      }
      return isResult
    },
    async getProofs (context, id) {
      const response = await api.get(`${ endpoint.proof(id)}?page_size=100`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'proofs', data: response.data })
      }
    },
    async setProofs (context, data) {
      const files = data.body.map(item =>
        item.files.map(file => {
          const body = new FormData()
          body.append('field_name', item.field_name)
          body.append('content_type', item.content_type)
          body.append('file_type', item.file_type)
          body.append('file', file)
          return api.post(endpoint.proof(data.id), { body: body })
        })
      )
      let isSuccess = null
      await Promise.all(files.flatMap(arr => arr)).then(responseArray => {
        let listRes = []
        responseArray.forEach(async response => {
          const res = await requestValidation(response)
          listRes.push(res)
          if (listRes.length === responseArray.length) {
            if (listRes.every(value => value)) {
              context.dispatch('getInspection', data.id)
              notify.success('notify.inspection.proof.success')
              isSuccess = true
              return true
            } else {
              notify.error('notify.inspection.proof.error')
              isSuccess = false
              return false
            }
          }
        })
      })
      return isSuccess
    },
    // Decision Issue
    async getDecisionIssue (context, id) {
      const response = await api.get(`${ endpoint.decisionIssue }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'decisionIssue', data: response.data.results[0] })
      }
      return isResult
    },
    async getDecisionIssueId (context, id) {
      const response = await api.get(`${ endpoint.decisionIssue }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'decisionIssueRejectId', data: response.data.results[0].id })
      }
      return isResult
    },
    async setDecisionIssueSign (context, data) {
      const response = await api.post(endpoint.decisionIssueSign, { body: { document: data.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        //because celery give data
        setTimeout(async () => {
          await context.dispatch('getInspection', data.inspectionID)
          if (context.state.inspection.status_document === statusesList.inspectionRejected) {
            context.commit('SET_DATA', { store, state: 'decisionIssue', data: {} })
          } else {
            await context.dispatch('getDecisionIssue', data.inspectionID)
          }
          await context.dispatch('getCertificate', data.inspectionID)
        }, 1000)
      }
      return isResult
    },
    async getDecisionIssuingPDF (context, id) {
      const response = await api.get(endpoint.pdfDecisionIssuing(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    // certificate
    async getCertificate (context, id) {
      const response = await api.get(`${ endpoint.certificate }?inspection=${ id }`)
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', {
          store,
          state: 'certificate',
          data: response.data.results[0] === undefined ? {} : response.data.results[0]
        })
      }
      return isResult
    },
    async sendToFinalizationInspection (context, body) {
      const response = await api.patch(endpoint.decisionIssueAction(body.id), { body: body.payload })
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getDecisionIssue', body.inspectionID)
      await context.dispatch('getInspection', body.inspectionID)
      return isResult
    },
    async addNoteForCertificate (context, body) {
      const response = await api.patch(endpoint.decisionIssueAction(body.id), { body: body.payload })
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getDecisionIssue', body.inspectionID)
      return isResult
    },
    async setCertificate (context, data) {
      const response = await api.patch(`${ endpoint.certificate }${ data.certificateId }/`,
        { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getCertificate', data.inspectionID)
        await context.dispatch('getDecisionIssue', data.inspectionID)
        await context.dispatch('getInspection', data.inspectionID)
      }
      return isResult
    },
    async setCertificateSign (context, data) {
      const response = await api.post(endpoint.certificateSign, { body: { document: data.id }})
      const isResult = await requestValidation(response)
      if (isResult) {
        const responseAppendix = await api.post(endpoint.certificateAppendixSign, { body: { document: data.appendixID }})
        const isResultAppendix = await requestValidation(responseAppendix)
        //because celery give data
        if (isResultAppendix) {
          setTimeout(async () => {
            await context.dispatch('getCertificate', data.inspectionID)
            await context.dispatch('getDecisionIssue', data.inspectionID)
            await context.dispatch('getInspection', data.inspectionID)
          }, 700)
        }

      }
      return isResult
    },
    async getCertificatePDF (context, id) {
      const response = await api.get(endpoint.pdfCertificate(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    async getCertificateAppendixPDF (context, id) {
      const response = await api.get(endpoint.pdfCertificateAppendix(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },
    async getMeasurementResult (context, id) {
      const response = await api.get(endpoint.measurementResult(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'measurementResult', data: response.data })
      }
    },
    setShowPassedMeasurement (context, data) {
      context.commit('SET_DATA', { store, state: 'showPassMeasurementIndex', data: data })
    },
    async getCarcassTypesByCategory (context, id) {
      const response = await api.get(endpoint.getCarcassTypesByCategory(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'carcassTypes', data: response.data })
      }
      return isResult
    },
    async inspectionChangeResponsiblePerson (context, payload) {
      const response = await api.patch(endpoint.inspectionChangeResponsiblePerson(payload.inspectionId),
        { body: payload.assignedTo })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getInspection', payload.inspectionId)
      return isResult
    },
    async getMeasurementEquipmentList (context, data) {
      const response = await api.get(endpoint.equipmentList({ number: data.number, type: data.type }))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'equipmentList', data: response.data })
      }
      return response.data
    },
    async getInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.get(endpoint.measurementInfo(params))
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.get(endpoint.measurementInfoOTK(params))
      }

      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionMeasurementResult', data: response.data })
        return response.data
      }
    },
    async saveInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.post(endpoint.measurementInfo(params), { body: data.body })
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.post(endpoint.measurementInfoOTK(params), { body: data.body })
      }

      if (await requestValidation(response)) {
        return response.data
      }
    },
    async updateInspectionMeasurementInfo (context, data) {
      const params = {
        inspection: data.inspection,
        interaction: data.interaction,
        type: data.type
      }
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.patch(endpoint.measurementInfo(params), {body: data.body})
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.patch(endpoint.measurementInfoOTK(params), {body: data.body})
      }
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'inspectionMeasurementResult', data: response.data })
        return response.data
      }
    },
    async startMeasurementZigBee (context, params) {
      let response = null
      if (router.currentRoute.query.measurementFor === 'certification') {
        response = await api.post(endpoint.startMeasurementLightZigBee(params))
      }
      if (router.currentRoute.query.measurementFor === 'technical_control') {
        response = await api.post(endpoint.startMeasurementLightZigBeeOTK(params))
      }

      if (response && await requestValidation(response)) {
        return response
      } else {
        if (response?.code === 400) context.dispatch('getEquipmentsList', { type_inspection: 'light' })
        return false
      }
    },
    async terminateInspectionMeasurement (context, id) {
      let response = await api.post(endpoint.terminateInspection(id))
      if (response && await requestValidation(response)) {
        return response
      }
    },
    async sendCertificateToUAS (context, body) {
      const response = await api.get(endpoint.sendCertificateToUAS(body.certificateId))
      const isResult = requestValidation(response)
      if (isResult) await context.dispatch('getCertificate', body.inspectionId)
      return isResult
    },
    async addManualInspectionProtocolNumber (context, payload) {
      const response = await api.patch(endpoint.addInspectionProtocolNumber(payload.inspectionId), { body: payload.body })
      const isResult = await requestValidation(response)
      return isResult ? response.data : isResult
    },
    async updateManualCertificationNumber (context, payload) {
      const response = await api.patch(endpoint.manualCertificationNumber(payload.certificateId), { body: payload.body })
      const isResult = await requestValidation(response)
      return isResult ? response.data : isResult
    }
  }
}
